export const BASE_URL = `${window.location.protocol}//${window.location.hostname}${window.location.port ? ":" + (window.location.port === "3000" ? "3001" : window.location.port) : ""}`
export const API_ROOT = `${BASE_URL}/api`
